import styled from "styled-components";

export const MessageContactFormStyled = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0.5;
    transform: translate(-50%, -50%);
    background-color: white;
    z-index: 99;
    display: none;
    padding: 2rem;

    div {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    }
`;